/**
 * The two strings that put the selected domain in the URL, and the only place either is written.
 *
 * Clarity's own workspace route is `/d/:domainId/:tab` (their CLR-210). This port keeps that shape
 * one level down, under the section it already owns: **`/clarity/d/:domainId/:tab`**. The `/clarity`
 * prefix and the tab segments are the application's and the section's business; what lives here is
 * only the pair that three layers have to agree on and that nothing would otherwise hold together —
 * the route table that declares the parameter, the tab links that build it, and the domain context
 * that reads it back.
 *
 * They are in `type:util` because that is the one layer every one of those three may reach: the
 * route table is `type:feat`, the context implementation is `type:domain`.
 *
 * A drift between them fails silently rather than loudly, which is why they are constants and not
 * literals: a route declaring `:domain` while the context reads `domainId` yields a URL that matches,
 * a component that renders, and a selection that is forever `null`.
 */

/** The fixed segment that introduces the domain — the `d` of `/clarity/d/:domainId/pulse`. */
export const CLARITY_DOMAIN_ROUTE_SEGMENT = 'd';

/** The route parameter carrying the domain's id. Declared as `:domainId` in the route table. */
export const CLARITY_DOMAIN_ROUTE_PARAM = 'domainId';

/**
 * The route parameter carrying the tab segment where one route matches every tab — the System Domain
 * branch, whose matcher hands it over and whose page reads it back (brain's `:tab?`).
 */
export const CLARITY_TAB_ROUTE_PARAM = 'tab';
